const files = require.context('@/components/autoInstall', true, /\.vue$/)

export default {
  install (Vue) {
    files.keys().forEach((key) => {
      const component = files(key).default || files(key)
      console.log(component.name, component)
      Vue.component(component.name, component)
    })
  }
}
